import React from 'react'
import './Gallery.css';

const Gallery = () => {
  return (
    <div>
        <div class="container_dd">
        <h1 class="heading_dd"></h1>

        <div class="gallery">
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./ssvn1.jpg"
              alt="person writing in a notebook beside by an iPad, laptop, printed photos, spectacles, and a cup of coffee on a saucer"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./sss21.jpg"
              alt="sunset behind San Francisco city skyline"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./ssvn3.jpg"
              alt="people holding umbrellas on a busy street at night lit by street lights and illuminated signs in Tokyo, Japan"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./school1.jpeg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./school2.jpeg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./school3.jpeg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./school4.jpeg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./ssvn4.jpg"
              alt="man wearing a black jacket, white shirt, blue jeans, and brown boots, playing a white electric guitar while sitting on an amp"
            />
          </div>
       

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./ssvn5.jpg"
              alt="man wearing a black jacket, white shirt, blue jeans, and brown boots, playing a white electric guitar while sitting on an amp"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./ssvn6.jpg"
              alt="back view of woman wearing a backpack and beanie waiting to cross the road on a busy street at night in New York City, USA"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./ssvn7.jpg"
              alt="man wearing a black jacket, white shirt, blue jeans, and brown boots, playing a white electric guitar while sitting on an amp"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./ssvn8.jpg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./ssvn9.jpg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./ssvn10.jpg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./ssvn11.jpg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./ssvn12.jpg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./school5.jpg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./school6.jpg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Gallery